var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_add_user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_add_user",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4,0 L34,0 L34,34 L3.4,34 C1.52223185,34 -1.10230735e-15,32.4777681 -1.33226763e-15,30.6 L-4.4408921e-16,3.4 C-6.74049485e-16,1.52223185 1.52223185,-9.87327216e-16 3.4,-1.33226763e-15 Z",
    id: "Rectangle-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4-Copy",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    stroke: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,11.5 L16,11.5 L16,12.5 L12.5,12.5 L12.5,16 L11.5,16 L11.5,12.5 L8,12.5 L8,11.5 L11.5,11.5 L11.5,8 L12.5,8 L12.5,11.5 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddUser);
export default __webpack_public_path__ + "sanerret-static/media/ic_add_user.779a80887935e9064e7b3c1e51e8bfcb.svg";
export { ForwardRef as ReactComponent };